export const RAPORSEMESTER_GET = 'RAPORSEMESTER_GET';
export const RAPORSEMESTERDETAIL_GET = 'RAPORSEMESTERDETAIL_GET';